import {inject, Injectable} from '@angular/core';
import {TutorialStore} from '../stores/tutorial.store';
import {QueryService} from '../modules/akita-mimic/services/query.service';
import {TutorialState} from '../modules/akita-mimic/models/store-states/tutorial-state.model';
import {combineLatest, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {AppQuery} from './app.query';

@Injectable({ providedIn: 'root' })
export class TutorialQuery extends QueryService<TutorialState> {
    public isTutorialHidden$: Observable<boolean> = this.select('isHidden');
    public isTutorialEnabled$: Observable<boolean>;
    private readonly appQuery = inject(AppQuery);

    public constructor() {
        const store = inject(TutorialStore);
        super(store);

        this.isTutorialEnabled$ = combineLatest([
            this.appQuery.preferences$,
            this.isTutorialHidden$
        ])
            .pipe(map(([preferences, isTutorialHidden]) => !isTutorialHidden && !!preferences?.showBeginnersHelp));
    }

    public getReadTutorialStepIds(): Array<string> {
        return this.getValue().readTutorialStepIds;
    }

    public getIsTutorialHidden(): boolean {
        return this.getValue().isHidden;
    }
}